import { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import _ from 'lodash';

import Link from 'next/link';

import { useRouter } from 'next/router';

import moment from 'moment';

import { Image } from '../shared';

import { WordPressImageTransformer } from '../../../utils/wordpress-image-transformer';

import useResponsive from '../../../utils/responsive';

import { eventService } from '../../services/homii-services';
import { a } from 'react-spring';

const MobileBlogCarousel = (props) => {

    const { isMobile } = useResponsive();
    const { data, title, showAll } = props;
    const [blogPostCount, setBlogPostCount] = useState(0);
    const [relatedTags, setRelatedTags] = useState([]);
    const [blogData, setBlogData] = useState([]);

    const router = useRouter();
    const currentSlug = _.get(router, 'query.slug');

    const nextButtonRight = 9;
    const backButtonRight = 11;

    const getScreenWidth = (referenceWidth) => {
        return window.innerWidth <= referenceWidth ? referenceWidth : 1920;
    };

    const containerRef = useRef(null);
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [transformValue, setTransformValue] = useState(0);
    const [cardWidth, setCardWidth] = useState(getScreenWidth(412));

    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentX, setCurrentX] = useState(0);
    const [diffX, setDiffX] = useState(0);     

    useEffect(() => {
        const handleResize = () => {
            setCardWidth(getScreenWidth(1366));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!containerRef.current) return;

        const container = containerRef.current;
        const activeCard = container.querySelectorAll('.mobile-blog-carousel-styled-image')[currentCardIndex];
        if (!activeCard) return;

        const containerWidth = container.parentElement.offsetWidth;
        const cardRect = activeCard.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();


        const cardCenter = cardRect.left + cardRect.width / 2;
        const containerCenter = containerRect.left + containerWidth / 2;

        setTransformValue(containerCenter - cardCenter);

    }, [currentCardIndex, cardWidth]);

    useEffect(() => {
        _.forEach(data, (post) => {
            if (_.get(post, 'acf.url_slug') === currentSlug) {
                setRelatedTags(_.get(post, 'acf.meta_data_tags'));
            }
        });
    }, []);

    useEffect(() => {
        const blogPosts = [];
        if (showAll) {
            data.filter(
                (x) =>
                    x.acf.meta_data_categories !== false &&
                    x.acf.meta_data_categories.map((_) => _.category === 'Blog'),
            ).map((_) => blogPosts.push(_));
        } else {
            const _relatedTags = relatedTags.map((_) => _.tag);
            const _blogs = data.filter(
                (x) =>
                    x.acf.meta_data_categories !== false &&
                    x.acf.meta_data_categories.map((_) => _.category === 'Blog') &&
                    x.acf.url_slug !== currentSlug &&
                    x.acf.meta_data_tags !== false,
            );

            _.forEach(_blogs, (_blog) => {
                const _blogTags = _blog.acf.meta_data_tags.map((_) => _.tag);
                _.forEach(_blogTags, (_tag) => {
                    if (_relatedTags.includes(_tag)) {
                        blogPosts.push(_blog);
                    }
                });
            });
        }
        setBlogData(blogPosts);
        setBlogPostCount(_.size(blogPosts));
    }, [relatedTags]);

    const trackWidth = `${blogPostCount * 100}%`;
    const wrapperWidth = `${(100 / blogPostCount).toFixed(5)}%`;

    const handleStart = (e) => {
        setIsDragging(true);
        // Use e.clientX for mouse events and e.touches[0].clientX for touch events
        setStartX(e.clientX || e.touches[0].clientX);
    };

    const handleMove = (e) => {
        if (!isDragging) return;
        const newCurrentX = e.clientX || e.touches[0].clientX;
        const newDiffX = newCurrentX - startX;
        setCurrentX(newCurrentX);
        setDiffX(newDiffX);
    };

    const handleEnd = () => {
        setIsDragging(false);
        if (diffX > 50) {
            // Dragged right, go to previous card
            goToPreviousCard();
        } else if (diffX < -50) {
            // Dragged left, go to next card
            goToNextCard();
        }
        setDiffX(0); // Reset the difference
    };     

    const goToNextCard = () => {
        if (currentCardIndex < blogPostCount - 1) {
            const newIndex = currentCardIndex + 1;
            setCurrentCardIndex(newIndex);
        } else {
            setCurrentCardIndex(0);
        }
    };

    const goToPreviousCard = () => {
        if (currentCardIndex > 0) {
            const newIndex = currentCardIndex - 1;
            setCurrentCardIndex(newIndex);
        }
    };

    const checkCategory = (categories) => {
        let isBlog = false;
        if (!categories) {
            return isBlog;
        }
        _.forEach(categories, (category) => {
            if (category.category === 'Blog') {
                isBlog = true;
            }
        });
        return isBlog;
    };

    const checkForTags = (tags) => {
        return _.map(tags, (tag, index) => {
            const type = _.toUpper(_.get(tag, 'tag'));
            return <span key={index}>{type}</span>;
        });
    };

    const onPostClicked = (slug) => {
        eventService.logCustomEvent('viewed-blog-post', {
            description: `User viewed ${slug} and was directed from home page`,
            slug,
        });
    };

    const renderCarouselItem = () => {
        const sortedPostByDate = blogData.sort(
            (a, b) => b.meta_data_publish_date - a.meta_data_publish_date,
        );
        return _.map(sortedPostByDate, (item, index) => {
            const blogTitle = _.get(item, 'acf.seo_title');
            const slug = _.get(item, 'acf.url_slug');
            const tags = _.get(item, 'acf.meta_data_tags');
            const featuredImagePre = _.get(item, 'acf.featured_image');
            const featuredImage = WordPressImageTransformer(featuredImagePre, 490, 100);
            const featuredImageAlt = _.get(item, 'acf.featured_image_alt');
            const postPublished = _.get(item, 'acf.meta_data_publish_date');
            const categories = _.get(item, 'acf.meta_data_categories');

            const isBlog = checkCategory(categories);
            if (!isBlog) {
                return null;
            }

            return (
                <div className="mobile-city-carousel-slider-wrapper" key={index}>
                    <li style={{ width: wrapperWidth, paddingBottom: '40%' }} className='mobile-city-carousel-slide'>
                        <div className="mobile-city-carousel-inner-slide">
                            <a className='mobile-blog-carousel-styled-anchor-tag' target="_blank" href={`/blog/posts/${slug}`} as={`/blog/posts/${slug}`}>
                                <div className='mobile-blog-carousel-styled-image-container'>

                                    <img
                                        src={featuredImage}
                                        alt={featuredImageAlt || 'blog-article'}
                                        id={`${slug}-carousel-button`}
                                        onClick={() => onPostClicked(slug)}
                                        className="mobile-blog-carousel-styled-image"
                                    />
                                    
                                </div>
                            </a>

                            <div className='mobile-blog-carousel-caption-container'>

                                <span>
                                    <span className='mobile-blog-carousel-caption'>{checkForTags(tags)}</span>
                                </span>

                                <span className='mobile-blog-carousel-published-date'>
                                    {moment(postPublished).format('DD.MM.YYYY')}
                                </span>

                            </div>

                            <p className="mobile-blog-carousel-styled-paragraph selected-blog">
                                {blogTitle}
                            </p>
                        </div>
                    </li>
                </div>
            );
        });
    };

    if (!isMobile) {
        return null;
    }

    return (
        <div className='mobile-blog-carousel-carousel-container'>

            <div className='mobile-blog-carousel-header-row'>
                <h2 className='mobile-blog-carousel-header-2'>{title || 'Featured Articles'}</h2>
                <a className='mobile-blog-carousel-anchor-tag' href="/blog" id="blog_link">Read all</a>
            </div>

            <div className='mobile-city-carousel'>
                <div className='mobile-city-carousel-slider'>
                    <div className='mobile-city-carousel-slider-tray-wrap'>
                        <ul ref={containerRef} style={{ width: trackWidth, transform: `translate3d(${transformValue}px, 0px, 0px)` }}
                            onMouseDown={handleStart}
                            onMouseMove={handleMove}
                            onMouseUp={handleEnd}
                            onMouseLeave={handleEnd} 
                            onTouchStart={handleStart}
                            onTouchMove={handleMove}
                            onTouchEnd={handleEnd}                         
                            className='mobile-city-carousel-slider-tray'>
                            {renderCarouselItem()}
                        </ul>
                    </div>
                </div>
                <div className="mobile-blog-carousel-button-container">
                    <button type="button" aria-label="Back"
                        className="mobile-city-carousel-button mobile-city-carousel-button-back"
                        onClick={goToPreviousCard}
                        role="button" aria-disabled="false" id="mobile-city-carousel-button-back" right="14">
                        <span
                            className="mobile-city-carousel-label">
                            <svg
                                className="mobile-city-carousel-icon-root"
                                focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z">
                                </path>
                            </svg>
                        </span>
                        <span className="mobile-city-carousel-ripple-root"></span>
                    </button>
                    <button type="button" aria-label="Next"
                        className="mobile-city-carousel-button mobile-city-carousel-button-next"
                        onClick={goToNextCard}
                        role="button" aria-disabled="false" id="mobile-city-carousel-button-next" right="11">
                        <span
                            className="mobile-city-carousel-label">
                            <svg
                                className="mobile-city-carousel-icon-root"
                                focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z">
                                </path>
                            </svg>
                        </span>
                        <span className="mobile-city-carousel-ripple-root"></span>
                    </button>
                </div>
            </div>

        </div>
    );
};

export default MobileBlogCarousel;

MobileBlogCarousel.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    showAll: PropTypes.bool,
};

